import React from 'react'
import courierService from '../Service/courierService'
import FormInput from './formTambah'
import {config} from '../Config/config'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

export default class index extends React.Component {

    courierModel = {
        name: "",
        create_by: localStorage.getItem(config.userid),
        create_on: "",
        modified_by: "",
        modified_on: "",
        deleted_by: "",
        deleted_on: "",
        is_delete: false
    }



    constructor() {
        super()
        this.state = {
            List: [],
            Model: this.courierModel,
            showModal: false,
            Mode: "",
            showModalDel: false,
            showModalSave: false,
            showModalDelete: false,
            errors: {},
            count: 0,
            TotalPage: 0,
            filter: {
                search: "",
                order: '',
                page: '1',
                pagesize: '5'
            }
        }
    }

    loadList = async () => {
        const respon = await courierService.getAllFilter(this.state.filter)
        const responCount = await courierService.countData()

        if (respon.success) {
            let count = 0
            if (responCount.result != undefined) {
                count = responCount.result.count
            }
            this.setState({
                List: respon.result,
                TotalPage: Math.ceil(count / this.state.filter.pagesize)
            })
        }
        console.log(this.state.List)
    }

    componentDidMount() {
        this.loadList()
    }

    createHandler = () => {
        this.setState({
            Mode: "Tambah",
            showModal: true,
            Model: this.courierModel
        })
    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            showModal: false,
            errors: {}
        })
    }

    cancelHandlerDel = () => {
        this.setState({
            showModalDel: false,
            showModalDelete: false,
            showModalSave: false
        })
    }

    changeHandler = field => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: value
            }
        })
    }


    checkedHandler = field => ({ target: { checked } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: checked
            }
        })
    }

    saveHandler = async () => {
        const responName = await courierService.dupeData(this.state.Model.name)
        var name = ""
        if (responName.success) {
            if (responName.result != undefined) {
                name = responName.result.name
            }
        }
        console.log(responName.result)

        if (this.handleValidation(name)) {
            if (this.state.Mode == "Ubah") {
                const respon = await courierService.EditData(this.state.Model)
                if (respon.success) {
                    this.loadList()
                    this.setState({
                        Model: this.courierModel,
                        showModal: false,
                        showModalSave: true
                    })
                }
            }
            else {
                const respon = await courierService.addData(this.state.Model)
                console.log(respon)
                if (respon.success) {
                    this.loadList()
                    this.setState({
                        Model: this.courierModel,
                        showModal: false,
                        showModalSave: true
                    })

                }
            }
        }
    }


    editHandler = async (id) => {
        const respon = await courierService.getById(id)
        console.log(respon)
        this.setState({
            Mode: "Ubah",
            showModal: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    softDeleteHandler = async (id) => {
        const respon = await courierService.getById(id)
        this.setState({
            showModalDel: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    saveHandlerDel = async () => {
        if (this.handleValidation()) {
            const respon = await courierService.softDeleteData(this.state.Model)
            console.log(respon)
            if (respon.success) {
                await this.loadList()
                this.setState({
                    Model: this.courierModel,
                    showModalDel: false,
                    showModalDelete: true
                })
            }
        }
    }

    filterHandler = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    handleValidation(cekName) {
        let fields = this.state.Model
        let errors = {}
        let formIsValid = true;

        //name

        if (cekName) {
            formIsValid = false
            errors["name"] = "Name is already taken"
        }

        if (!fields["name"]) {
            formIsValid = false
            errors["name"] = "Name cannot be empty"
        }

        this.setState({ errors: errors })
        return formIsValid
    }

    renderPagination() {
        let item = []
        for (let number = 1; number <= this.state.TotalPage; number++) {
            item.push(
                <PaginationItem key={number} active={number === this.state.filter}>
                    <PaginationLink onClick={() => this.changePageHandler(number)}>
                        {number}
                    </PaginationLink>
                </PaginationItem>
            )
        }
        return (
            <Pagination>{item}</Pagination>
        )
    }

    pageSizeHandler = (size) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["pagesize"]: size
            }
        }, () => this.loadList())
    }

    changePageHandler = (number) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["page"]: number
            }
        }, () => this.loadList())
    }




    render() {
        const { List, Model, showModal, showModalDel, showModalDelete, showModalSave, errors } = this.state

        return (
            <div class="container">
                <div class="text-center mb-3">
                    <h1>Kurir</h1>
                </div>
                <div class="input-group col-5 mb-1 float-left">
                    <input class="form-control rounded-left" type="text" placeholder="Search by Nama" onChange={this.filterHandler("search")} />
                    <div class="input-group-append" onClick={this.loadList}>
                        <button class="btn btn-primary rounded-right" type="button">
                            <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
                <button type="button" class="btn btn-success mb-3 float-right" onClick={() => this.createHandler()}>+ Tambah</button>
                <div className="input-goup-append">

                    <button type="button" class="btn btn-primary dropdown-toggle " data-toggle="dropdown" aria-expanded="true">
                        Show Data
                    </button>
                    <ul class="dropdown-menu">
                        <li><a href="#" onClick={() => this.pageSizeHandler('5')} className="dropdown-item">5</a></li>
                        <li><a href="#" onClick={() => this.pageSizeHandler('10')} className="dropdown-item">10</a></li>
                        <li><a href="#" onClick={() => this.pageSizeHandler('20')} className="dropdown-item">20</a></li>
                        <li><a href="#" onClick={() => this.pageSizeHandler('30')} className="dropdown-item">30</a></li>
                    </ul>
                </div>
                <table class="table table-bordered table-hover">
                    <thead class="thead-dark">
                        <tr class="text-center">
                            <th scope="col">Name</th>
                            <th scope="col">Create By</th>
                            <th scope="col">#</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            List.map(data => {
                                return (
                                    <tr class="text-center">
                                        <td class="table-primary">{data.name}</td>
                                        <td class="table-primary">{data.pembuat}</td>
                                        <td class="table-primary"><button class="btn btn-primary mr-2" onClick={() => this.editHandler(data._id)}>Edit</button>
                                            <button class="btn btn-danger" onClick={() => this.softDeleteHandler(data._id)}>Delete </button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>

                <div class="float-right">
                    {this.renderPagination()}
                </div>

                <FormInput
                    changeHandler={this.changeHandler}
                    checkedHandler={this.checkedHandler}
                    saveHandler={this.saveHandler}
                    Model={Model}
                    showModal={showModal}
                    showModalSave={showModalSave}
                    cancelHandler={this.cancelHandler}
                    handleChange={this.handleChange}
                    errors={errors}
                    Mode={this.state.Mode}
                    showModalDel={showModalDel}
                    showModalDelete={showModalDelete}
                    cancelHandlerDel={this.cancelHandlerDel}
                    saveHandlerDel={this.saveHandlerDel}
                    handleValidation={this.handleValidation}
                />
            </div>
        )
    }
}